import { render, staticRenderFns } from "./DigitalAnalyticsOverview.vue?vue&type=template&id=839fda92&"
import script from "./DigitalAnalyticsOverview.vue?vue&type=script&lang=js&"
export * from "./DigitalAnalyticsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports